import script from "./OrderTemplateUploadPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTemplateUploadPanel.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTemplateUploadPanel.vue?vue&type=style&index=0&id=1b96808c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b96808c"]])

export default __exports__